module.exports = __webpack_public_path__ + "fonts/eabc8be60dfb9a74d665ab480e331500.svg";